import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { formatDate } from '../../helpers/formatted-dates';
import { catchError } from '../../helpers/catch-error-case-manager'
import { useNavigate } from "react-router-dom";



const Notes = ({ work_order, onWorkOrderChange }) => {

    const navigate = useNavigate();
    const [isBtn, setIsBtn] = useState(false);
    const [addMode, setAddMode] = useState(false);
    const [isNoteModalOpen, setIsNoteModalOpen] = useState(null);


    const [notes, setNotes] = useState(null);
    const [noteStatuses, setNoteStatuses] = useState(null);


    const [noteAdd, setNoteAdd] = useState(null);
    const [noteEdit, setNoteEdit] = useState(null);

    const [inputError, setInputError] = useState(false);



    useEffect(() => {

        if (work_order?.work_order_id > 0) {
            getNoteStatuses();
            getNotes();
        }

    }, [work_order?.work_order_id,work_order?.status]);



    const getNoteStatuses = async (e) => {


        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/case-manager/get-note-statuses/" + work_order.work_order_id, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setNoteStatuses(response?.data?.note_statuses);
              

            } else {

                Swal.fire({ icon: "error", title: "Note Info", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error,navigate)

        });

    }




    const getNotes = async () => {

        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/case-manager/get-notes-by-work-order-id/" + work_order?.work_order_id,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {

                if (response?.data?.status) {

                    setNotes(response?.data?.notes)



                } else {
                    Swal.fire({ icon: "error", title: "note Info", text: response?.data?.message });
                    setIsBtn(false)
                }

            }).catch(function (error) {

                catchError(error,navigate)


            });


    }


    const addNote = async () => {

        let d = new Date();
        let day = d.getDay();
        let incrday = 0;

        if (day <= 2) {
            incrday = 3;
        } else if (day <= 5) {
            incrday = 5;
        } else if (day == 6) {
            incrday = 4;
        }

        d.setDate(d.getDate() + incrday);

        d = formatDate(d);
        // alert(d);

        setNoteAdd({
            note_status: "",
            follow_up_date: d,
            wo_status: "",
            case_manager_access: 0,
            note_description: "",
            note_internal_description: ""

        });
        setAddMode(true);

    }


    const saveNote = async (e) => {


        setIsBtn(true);
        let error_flag = false;


        if (!noteAdd?.note_status || !noteAdd?.follow_up_date || 
            !noteAdd?.wo_status || !/^\d{2}\/\d{2}\/\d{4}$/.test(noteAdd?.follow_up_date)) {

            error_flag = true;
        }

        if (error_flag) {

            setInputError(true);
            setIsBtn(false);

        } else {

            var note_info = {
                work_order_id: work_order?.work_order_id,
                note_status: noteAdd?.note_status,
                follow_up_date: noteAdd?.follow_up_date,
                wo_status: noteAdd?.wo_status,
                case_manager_access: noteAdd?.case_manager_access,
                note_description: noteAdd?.note_description,
                note_internal_description: noteAdd?.note_internal_description,

            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/case-manager/add-note", note_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    getNotes();
                    setAddMode(false)

                } else {

                    Swal.fire({ icon: "error", title: "Note Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {

                setIsBtn(false);
                catchError(error,navigate)

            });

        }


    }






    const isGreaterThanYesterday = async (e) => {

        let yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);

        const note_date = new Date(e);
        if (note_date >= yesterday)
            return true;
        else
            return false;



    }




    return (

        <>
            <div className="card card-form" >
                <div className="card-body p-0" >

                    <div className=" card-heading row m-0" >

                        <div className="col py-1">

                            <div className=" py-2 fw-bold text-dark">ACTIVITY HISTORY</div>

                        </div>
                        <div className="col py-1 text-end">

                       

                        </div>


                    </div>

                  
                    <>
                        {(notes) ?
                            <>

                                <div className="row px-3 py-2 gx-2">
                                    <div className="col-md-2 col-sm-2">
                                        <label className="control-label">Date </label>
                                    </div>
                                    <div className="col-md-8 col-sm-8">
                                        <label className="control-label">STATUS </label>
                                    </div>
                                    <div className="col-md-2 col-sm-2">
                                        <label className="control-label">UPDATED BY</label>
                                    </div>



                                </div>

                                {notes.map((p, index) => {
                                    return (
                                        <>
                                       
                                        <div className="row px-3 py-2 gx-2">
                                            <div className="col-md-2 col-sm-2">
                                                <label className="field-info" >{p?.note_date_formatted}</label>
                                            </div>
                                            <div className="col-md-8 col-sm-8">
                                                <label className="field-info tt-none" >



                                                    {p.note_status &&
                                                        <>
                                                            <b>Status:</b> {p.note_status} <br />
                                                        </>
                                                    }

                                                    {p.note_description && p.case_manager_access===1 &&
                                                        <>
                                                            <b>Note:</b> {p.note_description} <br />
                                                        </>
                                                    }

                                                   



                                                </label>
                                            </div>
                                            <div className="col-md-2 col-sm-2">                                               
                                                <label className="field-info" >{p?.note_author_type == 'A' ? <>MedRec Admin</> : p?.note_author}</label>
                                            </div>

                                        </div>
                                                
                                                </>
                                    )
                                })}


                            </>
                            :
                            <div className="row " >

                                <div className="col-xl-12 col-lg-12 py-4 " >

                                    <h5 className="px-3 " >No status update has been added yet.</h5>

                                </div>

                            </div>
                        }
                    </>




                </div>




            </div>






        </>

    )

}
export default Notes;